import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Hidden, Tab, Tabs } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SimplebarWrapper from './SimplebarWrapper';
import { Message } from '@mui/icons-material';
import { withTranslation } from 'react-i18next';
import { RightSideDrawer } from './LayoutStyles';
import { Typography } from '@totalsoft/rocket-ui';

let setContentFn = () => {},
  resetContentFn = () => {};
let showRightSideBarFn = () => {};

const RightSidebar = ({ showRightSideBar, open, handleRightDrawerToggle, drawerName, t }) => {
  const [content, setLocalContent] = useState(
    <>
      <Tabs value={0} variant='fullWidth' indicatorColor='secondary' textColor='secondary'>
        <Tab icon={<Message />} label={t('Messages')} />
      </Tabs>
      <Typography px={2} py={2} variant='subtitle2'>
        {t('NoMessages')}
      </Typography>
    </>
  );

  const setContent = content => {
    setLocalContent(content);
  };

  const showRightSideBarInternal = visible => {
    showRightSideBar(visible);
  };

  useEffect(() => {
    setContentFn = setContent;
    resetContentFn = resetContent;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const resetContent = () => {
    setLocalContent(
      <>
        <Tabs value={0} variant='fullWidth' indicatorColor='secondary' textColor='secondary'>
          <Tab icon={<Message />} label={t('Messages')} />
        </Tabs>
        <Typography px={2} py={2} variant='subtitle2'>
          {t('NoMessages')}
        </Typography>
      </>
    );
  };

  useEffect(() => {
    showRightSideBarFn = showRightSideBarInternal;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <Hidden smDown>
        <RightSideDrawer
          variant='persistent'
          anchor='right'
          open={open}
          onClose={() => handleRightDrawerToggle(drawerName)}
          ModalProps={{ keepMounted: true }}
        >
          <SimplebarWrapper>{content}</SimplebarWrapper>
        </RightSideDrawer>
      </Hidden>

      <Hidden mdUp>
        <RightSideDrawer
          variant='temporary'
          anchor='bottom'
          open={open}
          onClose={() => handleRightDrawerToggle(drawerName)}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          <SimplebarWrapper>
            <div>
              <div>
                <IconButton style={{ zIndex: 10001 }} onClick={() => handleRightDrawerToggle(drawerName)}>
                  <ChevronRightIcon />
                </IconButton>
              </div>
              <Divider />
            </div>
            {content}
          </SimplebarWrapper>
        </RightSideDrawer>
      </Hidden>
    </div>
  );
};

RightSidebar.propTypes = {
  handleRightDrawerToggle: PropTypes.func.isRequired,
  showRightSideBar: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  drawerName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
};

export const showRightSideBar = visible => {
  showRightSideBarFn(visible);
};

export const setContent = content => {
  if (setContentFn === undefined) {
    setTimeout(() => setContentFn(content));
  } else {
    setContentFn(content);
  }
};

export const resetContent = () => resetContentFn();

export default withTranslation()(RightSidebar);
